module.exports = __webpack_public_path__ + "static/img/why-1.21868303.jpg";